
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SEO } from './SEO';

const AboutSarvalok: React.FC = () => {
  const { t } = useTranslation(['about', 'seo']);
  const isGlobal = typeof window !== 'undefined' && (window as any).__isIndianLocale__ === false;
  
  return (
    <div className="bg-white text-black px-8 lg:px-20 py-4">
      <SEO
        title={t('seo:about.title', { defaultValue: 'About Sarvalok' })}
        description={t('seo:about.description', { defaultValue: "Discover Sarvalok's mission and heritage-driven approach to authentic knowledge." })}
        url="/about-us"
      />
      <h2 className="text-2xl font-semibold mb-6">{t('about.title', { defaultValue: 'About Sarvalok' })}</h2>
      
      {/* Sanskrit Quote */}
      <div className="text-center italic text-gray-600 mb-8">
        <div 
          className="text-2xl leading-10 mb-4" 
          style={{ fontFamily: "'Tiro Devanagari Sanskrit', serif" }}
        >
          न हि ज्ञानेन सदृशं पवित्रमिह विद्यते।
        </div>
        <p className="text-sm leading-6 mb-2">
          {t('about.sanskrit_quote_translation')}
        </p>
        <span className="font-medium text-gray-800">{t('about.sanskrit_quote_source')}</span>
      </div>
      
      <p className="mb-4">{t('about.bridging_text')}</p>

      <h3 className="text-xl font-semibold mb-4">{t('about.our_story_title')}</h3>
      <p className="mb-4">
        {t(isGlobal ? 'about.our_story_paragraph1_global' : 'about.our_story_paragraph1')}
      </p>
      <p className="mb-4">
        {t('about.our_story_paragraph2')}
      </p>

      <h3 className="text-xl font-semibold mb-4">{t('about.mission_vision_title')}</h3>
      <p className="mb-4">
        {t('about.mission_statement')}
      </p>
      <p className="mb-4">
        {t('about.vision_statement')}
      </p>

      <h3 className="text-xl font-semibold mb-4">{t('about.heritage_ai_title')}</h3>
      <p className="mb-4">
        {t('about.heritage_ai_intro')}
      </p>
      <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6">
        <p className="text-blue-800 font-medium">
          {t('about.google_startup_recognition')}
        </p>
      </div>
      <ul className="list-disc list-inside ml-6 mb-6">
        <li className="mb-2">
          <span className="font-semibold">{t('about.beyond_generic_ai_title')}</span> {t('about.beyond_generic_ai_description')}
        </li>
        <li className="mb-2">
          <span className="font-semibold">{t('about.accuracy_reliability_title')}</span> {t('about.accuracy_reliability_description')}
        </li>
        <li>
          <span className="font-semibold">{t('about.unique_insights_title')}</span> {t('about.unique_insights_description')}
        </li>
      </ul>
      
      <p className="mb-4">
        <span className="font-semibold">{t('about.efficiency_title')}</span> {t('about.efficiency_description')}
      </p>

      <h3 className="text-xl font-semibold mb-4">{t('about.platform_title')}</h3>
      <p className="mb-4">
        {t('about.platform_description')}
      </p>
      <ul className="list-disc list-inside ml-6 mb-6">
        <li className="mb-2">{t('about.user_type_scholars')}</li>
        <li className="mb-2">{t('about.user_type_yoga')}</li>
        <li className="mb-2">{t('about.user_type_seekers')}</li>
        <li className="mb-2">{t('about.user_type_students')}</li>
        <li>{t('about.user_type_explorers')}</li>
        <li>{t('about.user_type_institutions')}</li>
      </ul>

      <h3 className="text-xl font-semibold mb-4">{t('about.commitment_title')}</h3>
      <p className="mb-4">
        {t('about.commitment_description')}
      </p>

      <h3 className="text-xl font-semibold mb-4">{t('about.path_forward_title')}</h3>
      <p className="mb-4">
        {t('about.path_forward_paragraph1')}
      </p>
      <p className="mb-4">
        {t('about.path_forward_paragraph2')}
      </p>
    </div>
  );
};

export default AboutSarvalok;
